import React, { useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { loadHostDetail } from '../actions';
import { metricKeys } from '../constants';
import { responseLogWithNotification } from '../../../utils/utils';
import { optionClassFormatter } from '../../../utils/formatters';
import { sortByStatus } from '../parking-meter-utils';
import MobileParkingMeterPopup from './MobileParkingMeterPopup';
import { Button, Icons } from '../../../components/base/BootstrapComponents';

export default function MobileParkingMeterMatrix(props) {
  const {
    hostStatusesList = [],
    hostDetail,
    createReport = () => {},
  } = props;
  const [showParkingMeter, setShowParkingMeter] = useState(false);
  const dispatch = useDispatch();
  const onMarkerClick = item => {
    dispatch(loadHostDetail({ id: item.id, metricKeys })).then(() => {
      setShowParkingMeter(true);
    }).catch(responseLogWithNotification);
  };
  const list = hostStatusesList.sort(sortByStatus);
  return (
    <div className="matrix-frame-wrapper">
      <div className="frame matrix-frame position-relative g-0">
        <div className="matrix-wrapper row-cols-4">
          {list.map((item, key) => (
            <div key={key} className="matrix-element-wrapper">
              <div onClick={() => { onMarkerClick(item); }} className={classNames('matrix-element', optionClassFormatter(item.status))}>
                {item.host}
              </div>
            </div>
          ))}
        </div>
        <div className="matrix-button-wrapper">
          <Button className="matrix-button" variant="secondary" onClick={createReport}>
            <Icons customIcon className="matrix-button-icon" width={12} height={8} icon="description" />
            Сформировать отчет
          </Button>
        </div>
        {showParkingMeter ? <MobileParkingMeterPopup item={hostDetail} handleClose={() => setShowParkingMeter(false)} /> : null}
      </div>
    </div>
  );
}
